import classNames from 'classnames';
import React from 'react';
import styles from './main-navigation-large-menu-item-wrapper.module.scss';

export interface MainNavigationLargeMenuItemWrapperProps {
  /** The aria label to apply */
  ariaLabel?: string;
  /** The content to center in the wrapper */
  children: React.ReactNode;
  /** The class name to apply */
  className?: string;
  /** Indicates whether the menu item is active */
  isActive?: boolean;
  /** Indicates whether this is a priority item */
  isPriority?: boolean;
  /** An event that is triggered on click */
  onClick?: (
    event?: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>,
  ) => void;
}

const MainNavigationLargeMenuItemWrapper = ({
  ariaLabel,
  children,
  className,
  isActive = false,
  isPriority = false,
  onClick,
}: MainNavigationLargeMenuItemWrapperProps) => {
  const classNameProps = classNames(styles.component, className, {
    [styles.isSecondary]: isPriority,
  });

  return (
    <button
      aria-expanded={isActive}
      aria-label={ariaLabel}
      className={classNameProps}
      onClick={onClick}
      type="button"
    >
      <div className={styles.content}>{children}</div>
    </button>
  );
};

MainNavigationLargeMenuItemWrapper.displayName =
  'MainNavigationLargeMenuItemWrapper';

export default MainNavigationLargeMenuItemWrapper;
